// Toggle the menu open and close when on mobile
export default function accordion() {
    const accordionTitles = document.querySelectorAll('.accordion-title');
    accordionTitles.forEach(title => {
        title.addEventListener('click', function() {
            const accordionItem = this.parentElement;
            accordionItem.classList.toggle('opened');
        });
    });
}
